import classNames from 'classnames/bind';
import React from 'react';
import toast from 'react-hot-toast';

import { ConfirmNotif, WarningCircle } from '../../assets/icons/Icons';
import styles from './Toast.module.scss';

const cx = classNames.bind(styles);

const success = (nodeOrMsg: React.ReactNode | string) => {
  return toast.custom(
    (t) => (
      <div
        className={cx('toast', { 'animate-enter': t.visible, 'animate-leave': !t.visible })}
        data-testid='toast-success'>
        <span className={cx('icon', 'success')}>{ConfirmNotif}</span>
        <div className={cx('text')}>{nodeOrMsg}</div>
      </div>
    ),
    {
      duration: 0,
    },
  );
};

const warning = (nodeOrMsg: React.ReactNode | string) => {
  return toast.custom(
    (t) => (
      <div
        className={cx('toast', { 'animate-enter': t.visible, 'animate-leave': !t.visible })}
        data-testid='toast-warning'>
        <span className={cx('icon', 'warning')}>{WarningCircle}</span>
        <span className={cx('text')}>{nodeOrMsg}</span>
      </div>
    ),
    {
      duration: 0,
    },
  );
};

export default { success, warning };
